const o = {
  name: "ArrowTopBottom",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.00015 14.5857L6 18.5855V1.99994H8V18.5858L12.0002 14.5857L13.4144 15.9999L7.00015 22.4141L0.585938 15.9999L2.00015 14.5857Z" fill="currentColor"/>
<path d="M10.5859 7.99991L17.0002 1.58569L23.4144 7.99991L22.0002 9.41412L18 5.41397V21.9999H16V5.41427L12.0002 9.41412L10.5859 7.99991Z" fill="currentColor"/>
</svg>
  `
};
export {
  o as ArrowTopBottom
};
